import styled, { css } from 'styled-components';
import {
  inputMediumStyles,
  Button,
  ButtonAppearance,
  Box,
  ButtonSize,
  IconStyled,
  SideSheetContentCol,
} from '@bechtel/gds';
import { SearchField } from '@bechtel/client-common';
import { TextFieldStyled } from '@bechtel/client-weld-common';
const footerButtonHeight = '40px';
const footerButtonWidth = '96px';
interface HighLightCardStyledProps {
  isActive?: boolean;
}
interface AssociatedWeldStyledProps {
  isSelected: boolean;
  isDisable: boolean;
}

export const AddButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.TERTIARY,
})`
  ${({ theme }) => css`
    width: auto;
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    padding-top: ${theme.spacings[400]};
    padding-right: ${theme.spacings[450]};
    padding-bottom: ${theme.spacings[400]};
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    &:hover {
      background-color: ${theme.colors.white};
    }
  `}
`;
export const DeleteButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.TERTIARY,
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.red[100]};
    color: ${theme.colors.grey[1000]};
    padding-top: ${theme.spacings[400]};
    padding-right: ${theme.spacings[450]};
    padding-bottom: ${theme.spacings[400]};
    margin-left: ${theme.spacings[450]};
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    &:hover {
      background-color: ${theme.colors.red[100]};
    }
  `}
`;
export const FooterButtonStyled = styled(Button).attrs({
  size: ButtonSize.MEDIUM,
  appearance: ButtonAppearance.SECONDARY,
})`
  ${({ theme }) => css`
    width: ${footerButtonWidth};
    height: ${footerButtonHeight};
    color: ${theme.colors.bechtel.blue[800]};
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    font-weight: ${theme.fontWeights[600]};
    margin-left: ${theme.spacings[400]};
  `}
`;

export const SaveButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.PRIMARY,
})`
  ${({ theme }) => css`
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    font-weight: ${theme.fontWeights[600]};
    margin-left: ${theme.spacings[400]};
  `}
`;

export const HighLightCardStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
})`
  ${({ theme }) => css`
    position: relative;
    border-bottom: 1px solid ${theme.colors.grey[300]};
    ${(props: HighLightCardStyledProps) =>
      props?.isActive
        ? css`
            background: ${theme.colors.bechtel.blue[100]};
            &:after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 5px;
              height: 100%;
              background: ${theme.colors.bechtel.blue[600]};
            }
          `
        : css`
            background: ${theme.colors.white};
          `}
  `}
`;

export const SkewedCardDarkStyled = styled(Box).attrs({ py: { sm: '450' }, pr: { sm: '450' }, pl: { sm: '100' } })`
  ${({ theme }) => css`
    position: relative;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      transform: skewX(-15deg);
      background: ${theme.colors.grey[200]};
      top: 0;
      right: ${theme.spacings[300]};
    }
  `}
`;

export const MaterialContainerStyled = styled(Box).attrs({
  my: { sm: '300' },
  justifyContent: { sm: 'space-between' },
  pr: { sm: '400' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
    border: 1px dashed ${theme.colors.grey[300]};
    border-radius: ${theme.radii[200]};
    cursor: pointer;
    ${(props: HighLightCardStyledProps) =>
      props?.isActive
        ? css`
            border: 1px dashed ${theme.colors.bechtel.blue[600]};
          `
        : null}
  `}
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
`;

export const SearchFieldStyled = styled(Box).attrs({
  p: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

export const AssociatedWeldStyled = styled(Box).attrs({
  px: { sm: '400' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    ${(props: AssociatedWeldStyledProps) =>
      props?.isSelected
        ? css`
            background: ${theme.colors.bechtel.blue[100]};
          `
        : css`
            background: ${theme.colors.white};
          `}
    ${(props: AssociatedWeldStyledProps) =>
      props?.isDisable
        ? css`
            opacity: 0.5;
            pointer-events: none;
            cursor: auto;
          `
        : css`
            opacity: 1;
            cursor: pointer;
          `}
    &:not(:last-child) {
      border-bottom: solid 1px ${theme.colors.grey[300]};
    }
  `}
`;

export const SideSheetContentColStyled = styled(SideSheetContentCol)`
  position: relative;
  bottom: 0;
`;
